import { b as __assign, a as __spreadArray, _ as __read } from '../../../_tslib-7a01aab4.js';
import { D as userInfoStore } from '../../../validateBalanceOnBet-af4f4a9b.js';
import '../store/chatStore.js';
import '../store/wageringStore.js';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../store/gameResultStore.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../store/forCrashGame/inputValidationStore.js';
import '../store/forCrashGame/totalBetStore.js';
import '../store/forCrashGame/resultReportStore.js';
import '../store/forCrashGame/gameStore.js';
import 'mobx';
import '../classes/httpResponse/index.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import '@microsoft/signalr';
import '../services/liveConnection/types.js';
import '../enums/BogLineGameConfig.js';
import './parseQuery.js';
import 'axios';
import '../enums/StatisticsSortingTypes.js';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import 'howler';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import '../services/api/BaseApiService.js';
import '../services/ApiServices.js';
import './deepCopy.js';
import '../polyfill.js';
import '../../../_commonjsHelpers-17aad09c.js';
import '../../../momentFormat-e9197995.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './isMobile.js';
import '../enums/bogGameNames.js';
import './updateHalfBets.js';

var updateLiveBetsWhitHalfBets = function (cashOutLivBets, cashOutData, cashOutInfos) {
    for (var i = 0; i < cashOutLivBets.length; i++) {
        if (cashOutLivBets[i].id === cashOutData.id) {
            cashOutLivBets[i] = __assign(__assign({}, cashOutLivBets[i]), { halfAmount: cashOutInfos[0].amount });
            cashOutLivBets.splice(i + 1, 0, __assign(__assign({}, cashOutData), { id: "".concat(cashOutData.id, "_"), halfAmount: cashOutInfos[0].amount, winAmount: cashOutInfos[0].winAmount, winCoinAmount: cashOutInfos[0].winCoinAmount }));
            i++;
            break;
        }
    }
    return __spreadArray([], __read(cashOutLivBets), false);
};
var updateOtherBetAndLiveHalfBets = function (livBets, otherBet) {
    var cashOutLivBets = [];
    var cashOutInfos = otherBet.additionalParams.cashOutInfos;
    for (var i = 0; i < livBets.length; i++) {
        var bet = livBets[i];
        var isSameCurrency = bet.currencyCode === userInfoStore.currencyCode;
        if (bet.id === otherBet.id) {
            if (otherBet === null || otherBet === void 0 ? void 0 : otherBet.cashOutHalf) {
                cashOutLivBets[i] = __assign(__assign({}, bet), { halfAmount: isSameCurrency ? cashOutInfos[0].amount : cashOutInfos[0].coinAmount, winCoinAmount: cashOutInfos[0].winCoinAmount });
                cashOutLivBets.splice(i + 1, 0, __assign(__assign({}, otherBet), { cashOutHalf: true, id: "".concat(otherBet.id, "_"), halfAmount: isSameCurrency ? cashOutInfos[0].amount : cashOutInfos[0].coinAmount, winCoinAmount: cashOutInfos[0].winCoinAmount, winAmount: cashOutInfos[0].winAmount }));
            }
            else {
                var halfCurrentBets = cashOutInfos.length ? cashOutInfos[1] : null;
                if (halfCurrentBets) {
                    var halfBet = __assign(__assign({}, otherBet), { winAmount: halfCurrentBets.winAmount, halfAmount: isSameCurrency ? halfCurrentBets.amount : halfCurrentBets.coinAmount, winCoinAmount: halfCurrentBets.winCoinAmount });
                    cashOutLivBets.push(halfBet);
                }
                else {
                    cashOutLivBets.push(otherBet);
                }
            }
        }
        else {
            cashOutLivBets.push(bet);
        }
    }
    return cashOutLivBets;
};
var updateInitialBetsWhitHalfBets = function (currentBets) {
    var _a;
    for (var i = 0; i < currentBets.length; i++) {
        var isOtherBet = +currentBets[i].userId !== +userInfoStore.userId;
        var isSameCurrency = currentBets[i].currencyCode === userInfoStore.currencyCode;
        var halfCurrentBets = (_a = currentBets[i]) === null || _a === void 0 ? void 0 : _a.betData.cashOutInfos;
        if (halfCurrentBets.length) {
            if (halfCurrentBets.length === 1) {
                currentBets[i] = __assign(__assign({}, currentBets[i]), { halfAmount: isOtherBet && !isSameCurrency
                        ? halfCurrentBets[0].coinAmount
                        : halfCurrentBets[0].amount, cashOutHalf: true, winAmount: 0 });
                currentBets.splice(i + 1, 0, __assign(__assign({}, currentBets[i]), { id: "".concat(currentBets[i].id, "_"), halfAmount: isOtherBet && !isSameCurrency
                        ? halfCurrentBets[0].coinAmount
                        : halfCurrentBets[0].amount, winAmount: halfCurrentBets[0].winAmount, winCoinAmount: halfCurrentBets[0].winCoinAmount, odd: halfCurrentBets[0].odd }));
                i++;
            }
            if (halfCurrentBets.length === 2) {
                currentBets[i] = __assign(__assign({}, currentBets[i]), { halfAmount: isOtherBet && !isSameCurrency
                        ? halfCurrentBets[0].coinAmount
                        : halfCurrentBets[0].amount, id: "".concat(currentBets[i].id, "_"), winAmount: halfCurrentBets[0].winAmount, winCoinAmount: halfCurrentBets[0].winCoinAmount, odd: halfCurrentBets[0].odd, cashOutHalf: true });
                currentBets.splice(i + 1, 0, __assign(__assign({}, currentBets[i]), { halfAmount: isOtherBet && !isSameCurrency
                        ? halfCurrentBets[1].coinAmount
                        : halfCurrentBets[1].amount, winAmount: halfCurrentBets[1].winAmount, winCoinAmount: halfCurrentBets[1].winCoinAmount, odd: halfCurrentBets[1].odd }));
                i++;
            }
        }
    }
};
var updateOtherAndLiveHalfBets = function (bets, otherCashOutBets) {
    var cashOutLivBets = [];
    var _loop_1 = function (i) {
        var bet = bets[i];
        var _a = __read(otherCashOutBets.filter(function (data) { return data.id === bet.id; }), 2), otherBet = _a[0], sameHalfOtherBet = _a[1];
        var isSameCurrency = bet.currencyCode === userInfoStore.currencyCode;
        if (sameHalfOtherBet) {
            var cashOutInfos = sameHalfOtherBet.additionalParams.cashOutInfos;
            cashOutLivBets[i] = __assign(__assign({}, otherBet), { halfAmount: isSameCurrency ? cashOutInfos[0].amount : cashOutInfos[0].coinAmount, winCoinAmount: cashOutInfos[1].winCoinAmount, winAmount: cashOutInfos[1].winAmount });
            cashOutLivBets.splice(i + 1, 0, __assign(__assign({}, otherBet), { id: "".concat(bet.id, "_"), halfAmount: isSameCurrency ? cashOutInfos[0].amount : cashOutInfos[0].coinAmount, winCoinAmount: cashOutInfos[0].winCoinAmount, winAmount: cashOutInfos[0].winAmount, cashOutHalf: true }));
        }
        else if (otherBet === null || otherBet === void 0 ? void 0 : otherBet.cashOutHalf) {
            var cashOutInfos = otherBet.additionalParams.cashOutInfos;
            cashOutLivBets[i] = __assign(__assign({}, bet), { halfAmount: isSameCurrency ? cashOutInfos[0].amount : cashOutInfos[0].coinAmount, winCoinAmount: cashOutInfos[0].winCoinAmount });
            cashOutLivBets.splice(i + 1, 0, __assign(__assign({}, otherBet), { cashOutHalf: true, id: "".concat(otherBet.id, "_"), halfAmount: isSameCurrency ? cashOutInfos[0].amount : cashOutInfos[0].coinAmount, winCoinAmount: cashOutInfos[0].winCoinAmount, winAmount: cashOutInfos[0].winAmount }));
        }
        else {
            var halfCurrentBets = (otherBet === null || otherBet === void 0 ? void 0 : otherBet.additionalParams.cashOutInfos.length)
                ? otherBet === null || otherBet === void 0 ? void 0 : otherBet.additionalParams.cashOutInfos[1]
                : null;
            if (halfCurrentBets) {
                var halfBet = __assign(__assign({}, otherBet), { winAmount: halfCurrentBets.winAmount, halfAmount: isSameCurrency ? halfCurrentBets.amount : halfCurrentBets.coinAmount, winCoinAmount: halfCurrentBets.winCoinAmount });
                cashOutLivBets.push(halfBet);
            }
            else {
                cashOutLivBets.push(otherBet || bet);
            }
        }
    };
    for (var i = 0; i < bets.length; i++) {
        _loop_1(i);
    }
    return cashOutLivBets;
};
var updateBetHistoryWhitHalf = function (historyData, BetStatus) {
    for (var i = 0; i < historyData.length; i++) {
        var current = historyData[i];
        var cashOutInfos = current.additionalParams.cashOutInfos;
        if (cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos.length) {
            if (!current.oldData && cashOutInfos.length === 1) {
                historyData[i] = __assign(__assign({}, current), { amount: cashOutInfos[0].amount, winAmount: cashOutInfos[0].winAmount, odd: cashOutInfos[0].odd, id: current.id + Math.random(), status: BetStatus.Win, oldData: true });
                historyData.splice(i + 1, 0, __assign(__assign({}, current), { amount: cashOutInfos[0].amount, odd: 0, oldData: true, winAmount: 0 }));
                i++;
            }
            else if (!current.oldData && cashOutInfos.length === 2) {
                historyData[i] = __assign(__assign({}, current), { amount: cashOutInfos[0].amount, winAmount: cashOutInfos[0].winAmount, odd: cashOutInfos[0].odd, id: current.id + Math.random(), oldData: true });
                historyData.splice(i + 1, 0, __assign(__assign({}, current), { amount: cashOutInfos[1].amount, winAmount: cashOutInfos[1].winAmount, odd: cashOutInfos[1].odd, oldData: true }));
                i++;
            }
            else if (!current.oldData) {
                historyData[i] = __assign(__assign({}, current), { oldData: true });
            }
        }
    }
    return historyData;
};

export { updateBetHistoryWhitHalf, updateInitialBetsWhitHalfBets, updateLiveBetsWhitHalfBets, updateOtherAndLiveHalfBets, updateOtherBetAndLiveHalfBets };
